import { AvatarDropdown, AvatarName, Question } from '@/components';
import { currentUser as queryCurrentUser, RouterAddress } from '@/services/ant-design-pro/api';
import { Splitter } from "antd";
import type { Settings as LayoutSettings } from '@ant-design/pro-components';
import { SettingDrawer } from '@ant-design/pro-components';
import type { RunTimeLayoutConfig } from '@umijs/max';
import { history, Link } from '@umijs/max';
import React, {lazy, Suspense, useEffect, useState} from 'react';
import defaultSettings from '../config/defaultSettings';
import {treeJoinList2} from './util/fun'
import { errorConfig } from './requestErrorConfig';
import Icon from '@ant-design/icons'
import * as icons from '@ant-design/icons'
const iconsdata:any = icons

const isDev = process.env.NODE_ENV === 'development';
const loginPath = '/user/login';

export const patchClientRoutes = async (data:any) => {
  let {routes} = data
  const menulist: any = localStorage.getItem('menu') || []
  const res = JSON.parse(menulist)
  let route = res
  
  route = route.filter((item: any) => item.menuType !== 'F')
  let list:any[] = []
  for (const item of route) {
    let Dom: any = null
    let data:any = {
      path: item.path,
      name: item.menuName,
      menuId: item.menuId,
      icon: <Icon component={iconsdata[item.icon]}></Icon>,
      parentId: item.parentId === '0' ? 'ant-design-pro-layout' : item.parentId
    }
    if (item.component && item.component.trim() != '' ) {
      try {
        Dom = await lazy(() => import('@/pages/'+item.component))
        data.element = (<Suspense fallback={<div>Loading...</div>}>
          <Dom></Dom>
        </Suspense>)
      } catch (err){
      }
    }
    list.push(data)
  }
  route = await treeJoinList2(list)
  const index = routes.findIndex((item: any) => item.id === 'ant-design-pro-layout')
  routes[index].children = [...routes[index].children, ...route]
  localStorage.setItem('reader', 'true')
};
/**
 * @see  https://umijs.org/zh-CN/plugins/plugin-initial-state
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: API.UserData;
  permissions?: any[];
  roles?: any[];
  loading?: boolean;
  fetchUserInfo?: () => Promise<API.CurrentUser | undefined>;
  fetchMenuInfo?: () => Promise<API.CurrentUser | undefined>;
}> {
  const fetchUserInfo = async () => {
    try {
      const msg = await queryCurrentUser({
        skipErrorHandler: true,
      });
      return msg.data;
    } catch (error) {
      history.push(loginPath);
    }
    return undefined;
  };
  const fetchMenuInfo = async () => {
    try {
      const msg = await RouterAddress();
      return msg.data;
    } catch (error) {
      history.push(loginPath);
    }
    return undefined;
  };
  // 如果不是登录页面，执行
  const { location } = history;
  if (location.pathname !== loginPath && location.pathname !== '/api' && location.pathname !== '/auth') {
    const currentUser = await fetchUserInfo();
    return {
      fetchUserInfo,
      fetchMenuInfo,
      currentUser: currentUser?.user,
      permissions: currentUser?.permissions,
      roles: currentUser?.roles,
      settings: defaultSettings as Partial<LayoutSettings>,
    };
  }
  return {
    fetchUserInfo,
    settings: defaultSettings as Partial<LayoutSettings>,
  };
}

// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: RunTimeLayoutConfig = ({ initialState, setInitialState }) => {
  return {
    // breadcrumbRender: false,
    menu: {
      request: async () => {
        const menulist: any = localStorage.getItem('menu') || []
        const res = JSON.parse(menulist)
        let route = res.filter((item: any) => item.menuType !== 'F' && item.menuType !== 'A')
        let router = route.map((item: any) => {
          return { path: item.path,
                    name: item.menuName,
                    layout: item.visible === '0',
                    menuId: item.menuId,
                    parentId: item.parentId,
                    icon: <Icon component={iconsdata[item.icon]}></Icon> 
                  }
          
        })
        route = await treeJoinList2(router)
        router = route.filter((item: any) => item.layout)
        return router
      }
    },
    actionsRender: () => [<Question key="doc" />],
    avatarProps: {
      src: initialState?.currentUser?.avatar,
      title: <AvatarName />,
      render: (_, avatarChildren) => {
        return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
      },
    },
    waterMarkProps: {
      content: initialState?.currentUser?.userName,
    },
    // footerRender: () => <Footer />,
    onPageChange: () => {
      const { location } = history;
      // 如果没有登录，重定向到 login
      if (!initialState?.currentUser && location.pathname !== loginPath) {
        history.push(loginPath);
      }
    },
    // links: isDev
    //   ? [
    //       <Link key="openapi" to="/umi/plugin/openapi" target="_blank">
    //         <LinkOutlined />
    //         <span>OpenAPI 文档</span>
    //       </Link>,
    //     ]
    //   : [],
    menuHeaderRender: undefined,
    // 自定义 403 页面
    // unAccessible: <div>unAccessible</div>,
    // 增加一个 loading 的状态
    childrenRender: (children) => {
      // if (initialState?.loading) return <PageLoading />;
      return (
        <>
          {children}
          {isDev && (
            <SettingDrawer
              disableUrlParams
              enableDarkTheme
              settings={initialState?.settings}
              onSettingChange={(settings) => {
                setInitialState((preInitialState) => ({
                  ...preInitialState,
                  settings,
                }));
              }}
            />
          )}
        </>
      );
    },
    ...initialState?.settings,
  };
};

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request = {
  ...errorConfig,
};
